import styled from 'styled-components'

export const HiddenBox = styled.div`
  visibility: hidden;
  height: 0;
`
